import React, { Component } from "react";
import { connect } from "react-redux";
import "./style.scss";
import { pathToJS, firebaseConnect } from "react-redux-firebase";

class Account extends Component {
  constructor(props) {
    super(props);
    console.log(props);
    // Call with info
  }
  add() {
    this.createNewUser({
      email: "timmy.garrabrant@gmail.com",
      password: "changeit",
      displayName: "Timmy Garrabrant",
      role: "admin"
    });
  }

  createNewUser({ email, password, displayName, role }) {
    this.props.firebase.createUser(
      { email, password, signIn: "false" },
      { displayName: displayName, role: role, email: email }
    );
  }

  componentDidMount() {
    this.props.dispatch({
      type: "FETCH_ACCOUNT"
    });
  }

  logout() {
    this.props.firebase.logout();
  }

  componentWillReceiveProps(props) {}
  render() {
    return (
      <div className="challenge-creator">
        <div className="toolbar">
          <h1>Account</h1>
        </div>
        <div className="content">
          <div className="page">
            <div className="max-width" />
            <button onClick={this.logout.bind(this)}>Logout</button>
            <button onClick={this.add.bind(this)}>NEw User</button>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  // Map state to props
  ({ firebase }) => ({
    auth: pathToJS(firebase, "auth"),
    profile: pathToJS(firebase, "profile")
  })
)(firebaseConnect(["/users"])(Account));



// WEBPACK FOOTER //
// ./src/routes/account/index.js